import { combineReducers } from "redux";
import movieReducer from "./movieReducer";
import genreReducer from "./genreReducer";

const rootReducer = combineReducers({
  genres: genreReducer,
  movies: movieReducer,
});

export default rootReducer;
